import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "M1.666 3.322c0-.583.473-1.055 1.056-1.055h14.555c.583 0 1.056.472 1.056 1.055v14.556c0 .583-.473 1.055-1.056 1.055H2.722a1.056 1.056 0 0 1-1.056-1.055V3.322z",
      stroke: "currentColor",
      "stroke-width": "1.056"
    }, null, -1),
    _createElementVNode("path", {
      d: "M6.596 10.6H13.4",
      stroke: "currentColor",
      "stroke-width": "1.056",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }